import {useEffect, useState} from "react"
import {useNavigate} from "react-router-dom"

import {
    ChatParticipant,
    listPrivateChatPeersApi,
} from "../../../features/chat/api/chat.api"

import {Avatar} from "../../../shared/ui/Avatar"

export const CoursePrivatePeersList = (
    {courseId}: { courseId: string }
) => {
    const navigate = useNavigate()

    const [peers, setPeers] = useState<ChatParticipant[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const load = async () => {
            setLoading(true)
            try {
                const res = await listPrivateChatPeersApi(courseId)
                setPeers(res.data)
            } finally {
                setLoading(false)
            }
        }

        load()
    }, [courseId])

    if (loading) {
        return (
            <div className="bg-white border rounded-2xl p-5 text-gray-400">
                Loading participants...
            </div>
        )
    }

    if (!peers.length) {
        return (
            <div className="bg-white border rounded-2xl p-8 text-center text-gray-500">
                <div className="text-4xl mb-3">👥</div>
                <div className="font-semibold">
                    No participants yet
                </div>
                <div className="text-sm">
                    Private chats will appear here once students join
                </div>
            </div>
        )
    }

    return (
        <div className="bg-white border rounded-2xl p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-5">
                <div>
                    <div className="text-lg font-semibold">
                        Private discussions
                    </div>
                    <div className="text-sm text-gray-500">
                        Select a student to open a private chat
                    </div>
                </div>

                <span
                    className="
                        text-xs
                        px-2 py-1
                        rounded-full
                        bg-gray-100
                        text-gray-600
                        font-medium
                    "
                >
                    {peers.length} students
                </span>
            </div>

            {/* List */}
            <div className="space-y-3">
                {peers.map((peer) => (
                    <div
                        key={peer.user_id}
                        onClick={() =>
                            navigate(
                                `/courses/${courseId}/chat/private/${peer.user_id}`
                            )
                        }
                        className="
                            group
                            flex items-center justify-between
                            p-4
                            border
                            rounded-xl
                            cursor-pointer
                            transition
                            hover:bg-gray-50
                            hover:border-emerald-200
                        "
                    >
                        {/* Left */}
                        <div className="flex items-center gap-4 min-w-0">
                            <Avatar
                                name={peer.full_name}
                                src={peer.avatar}
                                size={40}
                            />

                            <div className="min-w-0">
                                <div className="font-medium truncate">
                                    {peer.full_name}
                                </div>
                                <div className="text-sm text-gray-500">
                                    Private chat
                                </div>
                            </div>
                        </div>

                        {/* Arrow */}
                        <div
                            className="
                                text-gray-300
                                group-hover:text-gray-400
                                transition
                            "
                        >
                            →
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
